import lifecycle from "recompose/lifecycle";
import withState from "recompose/withState";
import mapProps from "recompose/mapProps";
import compose from "recompose/compose";

/*
 * Creates a Higher Order Component that subscribes to
 * updates of state : BaoBab state object and rerenders
 * the wrapped components with the new tree provided as
 * a property with the name propName : String (default "tree")
 * */
export default (state, propName = "tree") => {
  // derive a standardised setter
  // name from propName
  let setterName = `set${propName.slice(0, 1).toUpperCase()}${propName.slice(
    1
  )}`;

  return compose(
    withState(propName, setterName, state.get()),
    lifecycle({
      componentWillMount() {
        this.setter = e => this.props[setterName](e.target.get()); //.log("propagating new state")
        state.on("update", this.setter);
      },
      componentDidMount() {
        this.props[setterName](state.get());
      },
      componentWillUnmount() {
        // make sure we unregister the
        // listener to avoid state updates
        // to components that don't exist anymore
        state.off("update", this.setter);
      }
    }),
    mapProps(props => ({
      ...props,
      [setterName]: value => state.set(value)
    }))
  );
};



// WEBPACK FOOTER //
// ./components/SubscribeState.js